import {
  UPDATE_THEME,
  UPDATE_ACTIVE_MODAL,
  TOGGLE_APP_DRAWER,
} from 'store/types';

export const updateTheme = (themeName) => (dispatch) => {
  dispatch({
    type: UPDATE_THEME,
    payload: themeName,
  });
};

export const updateActiveModal = (modalName) => (dispatch) => {
  dispatch({
    type: UPDATE_ACTIVE_MODAL,
    payload: modalName,
  });
};

export const toggleAppDrawer = () => (dispatch) => {
  dispatch({
    type: TOGGLE_APP_DRAWER,
  });
};
